import { useContext } from 'react'

import { PoliciesFormContext } from './policies-context'

export function usePoliciesForm() {
  const ctx = useContext(PoliciesFormContext)
  if (!ctx) {
    throw new Error('usePoliciesForm must be used within PoliciesFormProvider')
  }
  return ctx
}
